import type { OrderDetail, UpdateOrderAddressInput } from '@repo/api-contracts';
import { useInvalidateOrders } from '@/entities/order';
import { trpc } from '@/shared/api';

/**
 * 운영자 배송지 변경(orderManagement.updateShippingAddress, 주문 설계 §5-6). 성공하면 처리 뒤 상세(응답)를 캐시에 넣고 주문 목록과 주문 상태를 보여 주는
 * 견적 화면을 다시 불러온 뒤 그 상세를 돌려준다.
 * 실패는 서버 오류를 그대로 던진다 — 문구와 상태 충돌 재조회는 처리 대화상자(OrderActionDialog)가 정한다.
 */
export const useUpdateOrderAddress = (): ((
  input: UpdateOrderAddressInput,
) => Promise<OrderDetail>) => {
  const orders = useInvalidateOrders();
  const mutation = trpc.orderManagement.updateShippingAddress.useMutation();

  return async (input) => {
    const order = await mutation.mutateAsync(input);
    orders.putDetail(order);
    await Promise.all([orders.list(), orders.quotes()]);
    return order;
  };
};
